<template>
  <div class="edit">
    <div class="edit_top">
      <router-link to="/adminAccounts/edit" class="edit_router">
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="system_user_name_label detail_label">
            {{ adminUserNameLabel }}
          </div>
          <div class="system_user_name detail_top_title">
            {{ adminUserName }}
          </div>
        </div>
        <div class="detail_bottom">
          <div class="system_user_id_label detail_label">
            {{ adminUserIdLabel }}
          </div>
          <div class="system_user_id">
            {{ adminUserId }}
          </div>
          <div class="authority_label detail_label">
            {{ authorityLabel }}
          </div>
          <div class="authority">
            {{ authority }}
          </div>
          <div class="mail_address_label detail_label">
            {{ mailAddressLabel }}
          </div>
          <div class="mail_address">
            {{ mailAddress }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: '編集',
      adminUserNameLabel: '管理者名',
      adminUserIdLabel: '管理者ID',
      authorityLabel: '管理者権限',
      mailAddressLabel: 'メールアドレス'
    }
  },
  computed: {
    adminUserName() {
      return this.$store.state.adminAccounts.adminAccount.adminUserName
    },
    adminUserId() {
      return this.$store.state.adminAccounts.adminAccount.adminUserId
    },
    authority() {
      return this.$store.state.adminAccounts.adminAccount.authority
    },
    mailAddress() {
      return this.$store.state.adminAccounts.adminAccount.mailAddress
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/adminAccounts/adminAccountDetail.vue